import {createSlice} from "@reduxjs/toolkit";

const notificationsCounterSlice = createSlice({
    name: "notificationsCounter",
    initialState: 0,
    reducers:{
        setCounter: (state, action) => action.payload <= 0 ? 0 : action.payload, //payload is int
        incrementCounter: (state, action) => state + 1,
        decrementCounter: (state, action) => state > 1 ? state - 1 : 0
    }
});

export const { setCounter, incrementCounter, decrementCounter } = notificationsCounterSlice.actions;

export default notificationsCounterSlice.reducer;
